import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-registry-organisation-steps-wrapper',
    templateUrl: './registry-organisation-steps-wrapper.component.html',
    styleUrls: ['./registry-organisation-steps-wrapper.component.css'],
    standalone: false
})
export class RegistryOrganisationStepsWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
